import glamorous from 'glamorous';
import { mediaQueries } from '../../constants/mediaqueries.const';

import zeroLogo from '../../images/zero-logo.svg';

const ndeBlack = '#061B38';

// ::
export const AppBannerWrapper = glamorous.div(() => ({
  position: 'relative',
}));
AppBannerWrapper.displayName = 'AppBannerWrapper';

// ::
export const ZeroBannerWrapper = glamorous.div('ncss-base prl4-sm prl6-md pb10-sm va-sm-m', () => ({
  position: 'fixed',
  top: 0,
  left: 0,
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  flexDirection: 'row',
  zIndex: '500' /* Pop in front of next element */,
  background: '#F8F8F8',
  // padding: '0 25px 0 45px',
  color: '#333',
  height: '61px',
  lineHeight: '61px',
  // padding: 0,
  fontSize: '12px',
  boxShadow: '0 0 10px 10px rgba(10, 27, 54, 0.2)',
  userSelect: 'none',
  '> a': {
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s ease-in',
    '&:hover': {
      // borderColor: ndeBlack,
    },
  },
}));
ZeroBannerWrapper.displayName = 'ZeroBannerWrapper';

// ::
export const BackIcon = glamorous.div('g72-arrow-thin-left pr5-sm', () => ({
  color: '#000',
  fontSize: '16px',
}));
BackIcon.displayName = BackIcon;

// ::
export const ZeroLogo = glamorous.div(() => ({
  display: 'inline-block',
  width: '70px',
  height: '48px',
  background: `url(${zeroLogo}) no-repeat center center`,
  backgroundSize: 'contain !important',
}));
ZeroLogo.displayName = 'ZeroLogo';

// ::
export const HighFiveLogo = glamorous.div(() => ({
  display: 'inline-block',
  font: "HelveticaNeue-Bold",
  width: '70px',
  height: '48px',
  fontSize: "16px",
  backgroundSize: 'contain !important',
}));
HighFiveLogo.displayName = 'HighFiveLogo';

// ::
export const UserWrapper = glamorous.div('ncss-base', () => ({
  fontSize: '16px'
}));
UserWrapper.displayName = 'UserWrapper';

// ::
export const UserIcon = glamorous.span('g72-profile mr2-sm', () => ({
  color: ndeBlack,
  fontSize: '20px',
}));
UserIcon.displayName = 'UserIcon';

// ::
export const SwooshWrapper = glamorous.div(() => ({
  top: '10px',
  position: 'relative',
  height: '200px',
  backgroundSize: 'contain',
  // borderBottom: '3px solid #061b38',
  [mediaQueries.tablet]: {
    height: '230px',
  },
  [mediaQueries.desktop]: {
    height: '230px',
  },
}));
SwooshWrapper.displayName = 'SwooshWrapper';

// ::
export const AppTitle = glamorous.h1('ncss-brand', () => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: 'white',
  textTransform: 'uppercase',
  textAlign: 'center',
  fontSize: '18px',
  '> img': {
    width: '250px',
    margin: '0 auto',
    maxWidth: 'none',
  },
  [mediaQueries.tablet]: {
    '> img': {
      width: '300px',
    },
  },
  [mediaQueries.desktop]: {
    '> img': {
      width: '350px',
    },
  },
}));
AppTitle.displayName = 'AppTitle';

// ::
export const BurgerIcon = glamorous.div('g72-menu', () => ({
  color: '#000',
  position: 'relative',
  fontSize: '20px',
  top: '0px',
  left: '10px'
}));
BurgerIcon.displayName = BurgerIcon;

// ::
export const TabContainer = glamorous.div('ncss-base prl4-sm prl6-md pb10-sm', () => ({
  [mediaQueries.tablet]: {
    fontSize: '12px',
  },
  [mediaQueries.desktop]: {
    fontSize: '14px',
  },
  position: 'relative',
  fontSize: '10px',
  width: '30%',
  height: '48px',
  lineHeight: '48px',
  top: 0,
  display: 'flex',
  justifyContent: 'space-around',
  '> a': {
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s ease-in',
    '&:hover': {
      borderColor: ndeBlack,
    },
  },
}));
TabContainer.displayName = 'TabContainer';

// ::
export const TabContainerLogin = glamorous.div('ncss-base pr0-sm pr0-md pb10-sm', () => ({
  [mediaQueries.tablet]: {
    fontSize: '12px',
  },
  [mediaQueries.desktop]: {
    fontSize: '14px',
  },
  position: 'relative',
  fontSize: '10px',
  width: '7%',
  height: '48px',
  lineHeight: '48px',
  top: 0,
  display: 'flex',
  justifyContent: 'space-around',
  '> a': {
    borderBottom: '2px solid transparent',
    transition: 'border-color 0.2s ease-in',
    '&:hover': {
      borderColor: ndeBlack,
    },
  },
}));
TabContainerLogin.displayName = 'TabContainerLogin';




// WEBPACK FOOTER //
// ./src/components/AppBanner/AppBanner.style.js